import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useThemeStore = create(
  persist(
    (set) => ({
      darkMode:         true,
      sidebarCollapsed: false,
      toggleDark:    () => set((s) => ({ darkMode: !s.darkMode })),
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
    }),
    { name: 'mp-theme' }
  )
);

// Apply class to <html> on store changes
useThemeStore.subscribe((state) => {
  if (state.darkMode) {
    document.documentElement.classList.remove('light');
  } else {
    document.documentElement.classList.add('light');
  }
});

// Apply initial class immediately
const initial = useThemeStore.getState();
if (!initial.darkMode) {
  document.documentElement.classList.add('light');
}
